import { useContext, useEffect, useState } from "react";
import "./Navber.css";
import { LangContext, LangContextSet } from "../../../Context/LangContext";
export default function Navber() {
  const [scroll, setScroll] = useState(false);
  const [isOpan, setIsOpan] = useState(false);

  function List(props) {
    return (
      <li>
        <a href={props.idProps}> {props.name} </a>
      </li>
    );
  }

  const langCtx = useContext(LangContext);
  const langSetLang = useContext(LangContextSet);

  const handleChangLangContext = () => {
    if (langCtx === "ar") {
      langSetLang("en");
      localStorage.setItem("lang", "en");
    } else if (langCtx === "en") {
      langSetLang("ar");
      localStorage.setItem("lang", "ar");
    }
  };

  useEffect(() => {
    window.onscroll = function () {
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        setScroll(true);
      } else {
        setScroll(false);
      }
    };
  }, []);

  return (
    <div className={`navber ${scroll ? "active" : ""}`}>
      <div className="main-container">
        <div className="Logo">
          <img src="/images/logo.png" alt="logo" />
        </div>

        <div className={`element  ${isOpan ? "active" : ""}`}>
          <div className="logo-mune"> 
            <img src="/images/logo.png" alt="logo" />
          </div>
          <ul>
            <List idProps={"#hero"} name={text.Home[langCtx]} />
            <List idProps={"#aboutus"} name={text.About[langCtx]} />
            <List idProps={"#features"} name={text.features[langCtx]} />
            <List idProps={"#customer"} name={text.Customer[langCtx]} />
            <List idProps={"#packages"} name={text.packages[langCtx]} />
          </ul>
        </div>

        <div>
          <div className="language">
            <button onClick={handleChangLangContext}>
              <i className="bi bi-globe2"></i>
              <span>{langCtx}</span>
            </button>
          </div>
          <button className="btn-mune-res" onClick={() => setIsOpan(true)}>
            <div className="content">
              <div
                href="#"
                title="Navigation menu"
                className={`navicon ${isOpan ? "is-active" : ""}`}
                aria-label="Navigation"
              >
                <span className="navicon__item"></span>
                <span className="navicon__item"></span>
                <span className="navicon__item"></span>
                <span className="navicon__item"></span>
              </div>
            </div>
          </button>
        </div>
      </div>
      <div className={`bg-mune ${isOpan ? "active" : ""}`} onClick={() => setIsOpan(false)}></div>
    </div>
  );
}

const text = {
  Home: {
    ar: "الرئيسية",
    en: "Home",
  },
  About: {
    ar: "عن التطبيق",
    en: "About App",
  },
  features: {
    ar: "مميزات التطبيق",
    en: "App features",
  },
  Customer: {
    ar: "آراء العملاء",
    en: "Customer opinions",
  },
  packages: {
    ar: "باقات الاشتراك",
    en: "packages",
  },
};
